import { createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-6807963c")

_pushScopeId("data-v-6807963c")
const _hoisted_1 = { class: "login_wrap" }
const _hoisted_2 = { class: "login_hd flex_space_center" }
const _hoisted_3 = { class: "hd_left flex_start_center" }
const _hoisted_4 = { class: "title" }
const _hoisted_5 = {
  key: 2,
  class: "officia-login-container"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_FastLogin = _resolveComponent("FastLogin")!
  const _component_SingleTab = _resolveComponent("SingleTab")!
  const _component_Tabs = _resolveComponent("Tabs")!
  const _component_WxWebLogin = _resolveComponent("WxWebLogin")!
  const _component_OfficiaLogin = _resolveComponent("OfficiaLogin")!
  const _component_PhoneLogin = _resolveComponent("PhoneLogin")!
  const _component_KantuFooter = _resolveComponent("KantuFooter")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("img", {
          src: _ctx.viewModel.logo,
          class: "logo_icon",
          alt: ""
        }, null, 8, ["src"]),
        _createVNode("span", _hoisted_4, _toDisplayString(_ctx.viewModel.title) + "-快速登录", 1)
      ]),
      _createVNode("span", {
        class: "hd_close",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.clickClose && _ctx.clickClose(...args)))
      })
    ]),
    _withDirectives(_createVNode("div", null, [
      _createVNode(_component_FastLogin, { onUpdateFastLogin: _ctx.updateFastLogin }, null, 8, ["onUpdateFastLogin"])
    ], 512), [
      [_vShow, _ctx.viewModel.showFastLogin]
    ]),
    (!_ctx.viewModel.showFastLogin)
      ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
          (_ctx.isAiImageEditor)
            ? (_openBlock(), _createBlock(_component_SingleTab, {
                key: 0,
                title: "微信登录"
              }))
            : (_openBlock(), _createBlock(_component_Tabs, {
                key: 1,
                tabs: _ctx.viewModel.tabs,
                "tab-idx": _ctx.viewModel.tabIdx,
                onToggleTab: _ctx.toggleTab
              }, null, 8, ["tabs", "tab-idx", "onToggleTab"])),
          (_ctx.isAiImageEditor || _ctx.viewModel.tabIdx === 0)
            ? (_openBlock(), _createBlock("div", _hoisted_5, [
                (_ctx.isAiImageEditor)
                  ? (_openBlock(), _createBlock(_component_WxWebLogin, {
                      key: 0,
                      class: "officia-login",
                      appid: _ctx.viewModel.wxWebAppId,
                      size: 154
                    }, null, 8, ["appid"]))
                  : (_openBlock(), _createBlock(_component_OfficiaLogin, {
                      key: 1,
                      class: "officia-login",
                      size: 154,
                      "show-fast-login": _ctx.viewModel.showFastLogin
                    }, null, 8, ["show-fast-login"]))
              ]))
            : (_openBlock(), _createBlock(_component_PhoneLogin, { key: 3 })),
          _createVNode(_component_KantuFooter, {
            "tab-idx": _ctx.viewModel.tabIdx,
            "is-ai-image-editor": _ctx.isAiImageEditor
          }, null, 8, ["tab-idx", "is-ai-image-editor"])
        ], 64))
      : _createCommentVNode("", true)
  ]))
})